export default [
    {
        path: '/admin/monthly-over-times',
        name: 'monthly-over-times',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/monthly-over-time/index.vue')
    }
]
